// extracted by mini-css-extract-plugin
module.exports = {"timer_bar":"styles_timer_bar__1L_aS","timer":"styles_timer__3eBXQ"};